import client from './axiosClient';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const getProfile = async () => {
  return client.get(API_ENDPOINTS.PROFILE.PROFILE);
};

export const getAddress = async () => {
  return client.get(API_ENDPOINTS.PROFILE.ADDRESS);
};

export const getBankInfo = async () => {
  return client.get(API_ENDPOINTS.PROFILE.BANK_INFO);
};

export const getPersonalInfo = async () => {
  return client.get(API_ENDPOINTS.PROFILE.PERSONAL_INFO);
};

export const updateProfile = async (data: {
  firstName: string;
  language: string;
  lastName: string;
  middleName: string;
  phone: string;
}) => {
  return client.put(API_ENDPOINTS.PROFILE.PROFILE, data);
};

export const updateAddress = async (data: {
  City: string;
  Country: string;
  HouseNumber: string;
  PostCode: string;
  Street: string;
}) => {
  return client.put(API_ENDPOINTS.PROFILE.ADDRESS, data);
};

export const updateBankInfo = async (data: {
  bankName: string;
  bic: string;
  iban: string;
}) => {
  return client.put(API_ENDPOINTS.PROFILE.BANK_INFO, data);
};

export const updatePersonalInfo = async (data: {
  ahvNumber: string;
  civilStatus: string;
  crossBorderWorker: boolean;
  dateOfBirth: string;
  frameworkAgreementAccepted: boolean;
  nationality: string;
  numberOfChildren: number;
  religiousDenomination: string;
  singleIncome: string;
  tariffCode: string;
  workPermit: string;
}) => {
  return client.put(API_ENDPOINTS.PROFILE.PERSONAL_INFO, data);
};
